import React from "react";
import { IconButton, Stack } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { SOCIAL_MEDIA_LINKS } from "../Util/socialMediaLinks";

const ICONS = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  x: TwitterIcon,
  youtube: YouTubeIcon,
};

const BRAND_COLORS = {
  facebook: "#1877F2",
  instagram: "#E4405F",
  x: "#0f172a",
  youtube: "#FF0000",
};

function SocialMediaIcons({
  color = "inherit",
  brandColors = false,
  size = "medium",
  justifyContent = "flex-start",
}) {
  return (
    <Stack
      direction="row"
      spacing={0.5}
      justifyContent={justifyContent}
      flexWrap="wrap"
      useFlexGap
    >
      {SOCIAL_MEDIA_LINKS.map(({ key, href, label }) => {
        const Icon = ICONS[key];
        if (!Icon) return null;

        return (
          <IconButton
            key={key}
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            size={size}
            sx={{
              color: brandColors ? BRAND_COLORS[key] : color,
              width: 44,
              height: 44,
            }}
          >
            <Icon />
          </IconButton>
        );
      })}
    </Stack>
  );
}

export default SocialMediaIcons;
